<template>
  <sp-container rowgap="1" flex direction="column">
    <sp-fieldset class="context-menu__fieldset">
      <sp-label>Row Gap</sp-label>
      <InputRangeSlider
        v-model.number="model.ui.rowgap"
        min="0"
        max="100"
        step="1"
        unit="px"
        value-and-unit-width="6ch"
      />
    </sp-fieldset>

    <sp-fieldset class="context-menu__fieldset">
      <sp-label>Column Gap</sp-label>
      <InputRangeSlider
        v-model.number="model.ui.columngap"
        min="0"
        max="100"
        step="1"
        unit="px"
        value-and-unit-width="6ch"
      />
    </sp-fieldset>

    <Columns v-model="model.columns" />
  </sp-container>
</template>

<script setup>
import { computed, watch } from "vue";
import { toRemString } from "#ce/utils/css";
import InputRangeSlider from "#ce/components/SpLayoutBuilder/components/LayoutBuilderContextMenu/InputRangeSlider.ce.vue";
import Columns from "./ConfigurationColumns.ce.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const model = computed(() => props.modelValue);

watch(
  () => model.value.ui.rowgap,
  (value) => (model.value.rowgap = toRemString(value)),
);

watch(
  () => model.value.ui.columngap,
  (value) => (model.value.columngap = toRemString(value)),
);
</script>
